import { Navigate } from "react-router";
import { UsersTable } from "../users/UsersTable";
import { usePortalRole } from "./usePortal";
import styles from "./portal.module.css";

/** Company administrators only; the table reads the portal mount, never a company id. */
export function PortalUsers() {
  const role = usePortalRole();
  if (role === undefined) return <div className="page-loading" />;
  if (role !== "entity_admin") return <Navigate to="/portal" replace />;

  return (
    <>
      <div className="page-head">
        <div className="grow">
          <h1 className="display">Users</h1>
          <p className={styles.lede}>The people who can sign in to your company&apos;s portal, and what each may do.</p>
        </div>
      </div>
      <UsersTable source="portal" variant="tab" />
    </>
  );
}
